@if (lot$ | async; as data) {
<div>
  @if (userDetails$ | async; as userDetails) {
  <mat-card
    [ngClass]="{ hide: data._id === undefined || data._id === 'none selected' }"
  >
    <mat-card-header>
      <mat-card-subtitle> </mat-card-subtitle>
      <mat-card-title
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-evenly;
        "
      >
        <span class="text-xl font-medium">
          {{ data.commodity }}
          @if (data.product_type !== '-' && data.product_type !== null) {
          <span> {{ "- " + data.product_type }}</span>

          } @if (data.grade !== '-' && data.grade !== null) {
          <span> {{ "- " + data.grade }}</span>
          }
        </span>
        <mat-chip-set class="text-xs flex flex-row pl-2 items-start">
          @if (userDetails._id == data.user_id) {
          <mat-chip
            aria-label="sent-counter"
            disableRipple="true"
            class="text-xs bg-custom-blue purple-chip p-0"
            >My
          </mat-chip>
          } @if(!data.broker_indication){
          <mat-chip
            style="margin-left: 4px !important"
            disableRipple="true"
            [ngClass]="{
              'blue-chip': data.lot_type === 'Offer',
              'green-chip': data.lot_type === 'Bid'
            }"
          >
            {{ data.lot_type }}
          </mat-chip>
          } @if (data.indication && !data.broker_indication) {
          <mat-chip
            disableRipple="true"
            class="text-xs light-blue-chip p-0"
            matTooltip="Bid/Offer indication represents a non-binding expression of interest from a buyer (bid) or seller (offer) to transact at a specific price or within a price range."
            aria-label="Button that displays a tooltip when focused or hovered over"
            >Indication
          </mat-chip>
          }
          <app-jc-trading-indication
            [showIndication]="data.broker_indication"
          ></app-jc-trading-indication>
        </mat-chip-set>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="px-2">
        <div
          id="lots-details-grid"
          class="w-full my-2 grid grid-cols-2 text-base"
        >
          @if (canEdit()){
          <fa-icon
            class="col-span-1 col-start-2 justify-self-end hover:cursor-pointer"
            [icon]="faEdit"
            size="md"
            (click)="editLot()"
          ></fa-icon>
          }
          <div class="text-sm light:text-gray-300">Origin</div>
          <div class="font-medium">{{ data.origin }}</div>
          <div class="text-sm light:text-gray-300">Specifications</div>
          <div class="font-medium">
            @for (spec of data.specifications; track spec) { @if (spec.value !==
            '') {
            <span> {{ spec.title }} - {{ spec.value }} <br /> </span>
            } }
          </div>
          @if(data.documentations && data.documentations.length){
          <div class="text-sm light:text-gray-300">Documentations</div>
          <div
            class="font-medium text-base czol-span-2 doc-container text-right"
          >
            @for (doc of data.documentations; track doc) { @if (doc.value !==
            null) {
            <p class="text-left doc-row">
              {{ doc.title }} -
              <span class="font-normal text-sm">{{ doc.value }}</span>
            </p>
            } }
          </div>
          }
          <div class="font-base text-sm light:text-gray-300">Price</div>
          <div class="font-medium">
            @if(data.indication){~}
            {{ data.currency }}
            $ {{ data.price | priceType }}
            /
            {{ data.price_units }}
          </div>
          <div class="text-sm light:text-gray-300">Volume</div>
          <div class="font-medium">
            {{ data.volume_value | number }}
            {{ data.units === "Metric Tonnes" ? "MT" : data.units }}
          </div>
          <div class="text-sm light:text-gray-300">Delivery Type</div>
          <div class="font-medium">
            {{ data.delivery_type }}
          </div>
          <div class="text-sm light:text-gray-300">Location</div>
          <div style="text-wrap: wrap" class="font-medium">
            {{ data.destination }}
          </div>
          <div class="text-sm light:text-gray-300">Shipping</div>
          <div class="font-medium">
            <div>
              {{ data.ship_begin | date : "MMM d, y" }} -
              {{ data.ship_end | date : "MMM d, y" }}
            </div>
          </div>
          <div class="text-sm light:text-gray-300">Rules to Govern</div>
          <div class="font-medium">
            {{ data.rules_to_govern }}
          </div>
          <div class="text-sm light:text-gray-300">
            Grades/Weights to Govern
          </div>
          <div class="font-medium">
            {{ data.weight_grade_to_govern }}
          </div>
          <div class="text-sm light:text-gray-300">Container Tpe</div>
          <div class="font-medium">
            {{ data.container_type }}
          </div>
          <div class="text-sm light:text-gray-300">Payment terms</div>
          <div class="font-medium">
            {{ data.payment_term }}
          </div>
          <div
            class="text-sm light:text-gray-300"
            style="border-color: transparent"
          >
            Additional Notes
          </div>
          <div class="font-medium" style="border-color: transparent">
            {{ data.additional_info || "-" }}
          </div>
        </div>
        <div class="">Subject to approval of counter party</div>
      </div>
      <mat-divider></mat-divider>
    </mat-card-content>
    <mat-card-actions class="flex flex-row justify-end gap-2">
      @if (market$ | async; as marketType) { @if ( counterBtnActive() &&
      canNegotiateAndAccept() && marketType !== 'Farm' &&
      !data.broker_indication ) {
      <button
        class="text-sm counter-btn"
        mat-raised-button
        (click)="clickCounter()"
      >
        Counter
      </button>
      } } @if (userDetails._id === data.user_id) {
      <button class="text-sm revoke-btn" mat-raised-button (click)="revoke()">
        Cancel {{ data.lot_type | titlecase }}
      </button>
      } @if (acceptBtnActive() && canNegotiateAndAccept() && !data.indication) {
      <button
        class="text-sm"
        [ngClass]="acceptBtnActive() ? 'accept-btn' : 'disabled-btn'"
        mat-raised-button
        [disabled]="!acceptBtnActive()"
        (click)="accept()"
      >
        Accept
      </button>
      }
    </mat-card-actions>
    <mat-card-footer> </mat-card-footer>
  </mat-card>
  }
</div>
}
